/**
 * Formular.
 *
 * @class SP.sitekit.From
 */
SP.lang.Class.define("SP.sitekit.Form", {

	_el: null,

	_data: null,

	statics: {

		/**
		 * Liefert alle Validatoren, die am Element konfiguriert sind
		 */
		getValidators: function(validators) {
			var instances = [];
			if (validators) {
				if (SP.isArray(validators)) {
					for (var i = 0; i < validators.length; i++) {
						if (SP.isString(validators[i])) {
							validators[i] = {type:validators[i]};
						}
					}
				} else if (SP.isObject(validators)) {
					validators = [validators];
				} else if (SP.isString(validators)){
					validators = [{type:validators}];
				}

				for (var j = 0; j < validators.length; j++) {

					var validator = validators[j];
					var type = validator.type;
					var clazz = type.charAt(0).toUpperCase() + type.slice(1);
					if (SP.sitekit.form.validator[clazz]) {
						instances.push(new SP.sitekit.form.validator[clazz](validator));
					}
				}
			}

			return instances;
		},

		/**
		 * Encodiert ein Form-Data Objekt zu einem
		 * String mit URL-Parametern
		 * @param {FormData} formData
		 * @returns string
		 */
		encodeURIFormData: function (formData) {
			if (!(formData instanceof FormData)) {
				return "";
			}
			var parts = [];
			formData.forEach(function (value, name) {
				parts.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
			});
			return parts.join("&");
		}
	},

	/**
	 * Konstruktor
	 *
	 */
	init: function(el, data) {

		this._el = el;
		this._data = data;

		var me = this;
		if (this._el) {

			this._el.addEventListener("keypress", function(e) {
				if (me.isTriggerByKey(e, "Enter")) {
					if (data.submitOnEnter === true) {
						this.submit();
					} else if (data.submitOnEnter === false) {
						e.preventDefault();
					}
				}
			});

			this._el.addEventListener("submit", function (e) {
				if (me.isValid()) {
					return;
				}

				const firstInvalid = me.getInvalidFields()[0];

				const input = firstInvalid._el.querySelector('.SP-Field__control');
				if (input) {
					input.focus({
						preventScroll: true
					});
				}
				/* zum ersten Fehler Scrollen */
				firstInvalid._el.scrollIntoView({
					behavior: "smooth"
				});

				e.stopPropagation();
				e.preventDefault();
			});
		}

		if (data.focus) {
			var focusEl = document.getElementById(data.focus);
			if (focusEl) {
				focusEl.focus();
				window.scroll({
					top: (window.scrollY || window.pageYOffset) + focusEl.getBoundingClientRect().top,
					left: 0,
					behavior: "smooth"
				});
			}
		}

		// Fokus des Feldes setzten, wenn z.B. über eine Link mit Hash direkt auf des Feld gelinkt wird.
		window.addEventListener("hashchange", function () {
			var targetEl = el.querySelector(":target input, :target button, :target select");
			if (targetEl !== null) {
				targetEl.focus();
			}
		});


	},

	getFields: function () {
		const fields = SP.lang.Array.from(this._el.querySelectorAll("[data-sp-form-field]"));
		return fields
			.map(function (field) {
				return SP.sitekit.Bootstrap.getInstanceByElement(field, 'data-sp-form-field');
			})
			.filter(function (field) {
				return !!field;
			});
	},

	getInvalidFields: function () {
		const me = this;
		return me.getFields().filter(function (field) {
			if (me.hasInactiveFieldset(field._el)) {
				return false;
			}
			return field.validate() === false;
		});
	},

	isValid: function() {
		return this.getInvalidFields().length === 0;
	},

	hasInactiveFieldset: function(field) {
		var fieldset = SP.dom.Element.findParent(field, "[data-sp-form-fieldset]");
		if (fieldset) {
			var data = JSON.parse(fieldset.getAttribute("data-sp-form-fieldset"));
			if (data && data.checkbox) {
				var checkbox = document.getElementById(data.checkbox);
				if (checkbox && checkbox.checked === false) {
					return true;
				}
			}
			// verschachtelte Fieldsets untersützten.
			return this.hasInactiveFieldset(fieldset);
		}
		return false;
	},

	/**
	 * Gib, ob das event durch eine Bestimmte Taste erzeugt wurde
	 * @param Event e Event das geprüft werden soll.
	 * @param String key Taste auf die gefürt werden soll (z.B. 'Enter', ...)
	 */
	isTriggerByKey: function(e, key) {
		if (e.key) {
			return (e.key === key);
		} else {
			return (e.keyIdentifier === key);
		}
	}
});
